import React from 'react';  


export default function Counter() {  
    
    return (  
        <>  
            <section className="funfacts-area ptb-80">  
                <div className="container">  
                    <div className="section-title">  
                        <h2>We strive to weave together the fabric of our customers' expectations into every thread we produce</h2>  
                        <div className="bar"></div>  
                        <p>By blending innovation with tradition, we ensure that each product not only meets but exceeds the demands of our discerning clients, reflecting their unique vision and style</p>  
                    </div>  

                   
                   

                    <div className="map-bg">  
                        <img src="/img/map.png" alt="map"/>  
                    </div>  
                </div>  
            </section>  
        </>  
    );  
}